<template>
  <div>
    <div class="title pb-1 mb-3">{{ title }}</div>
    <div class="row">
      <div
        :class="columnClass"
        class="pb-3"
        v-for="inputData in inputs"
        :key="inputData.id"
      >
        <div class="d-flex">
          <div class="checkbox-wrapper">
            <input
              class="checkbox-hover"
              @click="toggleCheckbox(inputData)"
              type="checkbox"
              :checked="inputData.subscribed"
              :disabled="inputData.default"
            />
          </div>
          <div class="checkbox-hover" @click="toggleCheckbox(inputData)">
            {{ inputData.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "edit-interests-input-group",
  mixins: [HomebaseMixpanelMixin],
  props: ["title", "loadedInputs", "columnClass", "type"],
  data() {
    return {
      inputs: null,
    };
  },
  created() {
    this.initializeInputs();
  },
  methods: {
    initializeInputs() {
      let inputs = JSON.parse(JSON.stringify(this.loadedInputs));
      inputs = inputs.map((input) => ({ ...input, isModified: false }));
      this.inputs = inputs.sort((a, b) => (a.title < b.title ? -1 : 1));
    },

    toggleCheckbox(inputData) {
      // users are subcribed to some topics by default, ignore click in such case
      if (inputData.default) return;

      let id = inputData.id;
      let foundIndex = this.inputs.findIndex((input) => input.id == id);
      if (foundIndex < 0) return;

      this.inputs[foundIndex].subscribed = !this.inputs[foundIndex].subscribed;
      this.inputs[foundIndex].isModified = !this.inputs[foundIndex].isModified;
      
      // event tracking
      let trackSubscribed = this.inputs[foundIndex].subscribed;
      let trackTopic = this.inputs[foundIndex].title;
      this.trackSubscribedToTopic(trackSubscribed, trackTopic, this.type);
    },

    processSelections() {
      let filteredInputs = this.inputs.filter(input => input.isModified);
      let formattedSelections = filteredInputs.map((i) => {
        return {
          id: i.id,
          title: i.title,
          subscribe: i.subscribed,
        };
      });

      return formattedSelections;
    },
  },
};
</script>

<style scoped>
.title {
  font-family: artifaktElementBold;
  font-size: 16px;
  border-bottom: 1px solid #deddde;
}
.checkbox-wrapper {
  min-width: 20px;
}
.checkbox-hover:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/EditInterestsInputGroup.vue